import { createElement } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useDesignTokens, renderInlineCssVars } from '../../../theme';
import bundle from '../NovaComponents-ObjectMarker-gui-icu.properties';
import cn from './PopperContent.css.json';
import './PopperContent.css';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const PopperContent = (props: { onEscape?: () => void; content: string }) => {
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars(
    {
      pd: dt.spacing.core.m,
      'font-size-m': dt.fontNova.size.m,
    },
    'object-marker'
  );
  const localize = useTextLocalizer();
  const informationLabel = localize('information.label');
  return (
    <div className={cn.container} role="dialog" aria-label={informationLabel}>
      {/* This extra div is necessary for screen readers to read the content text correctly */}
      <div
        className={cn.popperContent}
        style={tokens}
        tabIndex={0}
        // eslint-disable-next-line @sas/i18n/jsx-to-localize
        onKeyDown={(event) => event.key === 'Escape' && props.onEscape?.()}
      >
        {props.content}
      </div>
    </div>
  );
};
